<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('analytics') }} -> {{ $t('statistics-branch') }}
    </h1>
    <div class="main__body">
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('filter') }}
        </h1>
        <div class="form-row">
          <div class="form-group">
            <label>{{ $t('select') }} {{ $t('period') }} {{ $t('from') }}</label>
            <input type="date" v-model="filter.afterDate" @change="this.getStatistics">
          </div>
          <div class="form-group">
            <label>{{ $t('select') }} {{ $t('period') }} {{ $t('before') }}</label>
            <input type="date" v-model="filter.beforeDate" @change="this.getStatistics">
          </div>
          <div class="form-group">
            <label>{{ $t('select') }} {{ $t('branch-1').toLowerCase() }}</label>
            <select class="custom-select" v-model="filter.branch" @change="this.getStatistics">
              <option value="0">{{ $t('select') }} {{ $t('branch-1').toLowerCase() }}</option>
              <option v-for="item in statistics" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="group__title">{{ $t('count-branches-per-day') }}</div>
      <div class="row">
        <div class="canvas">
          <line-chart :chart-data="chartData" :height="500" :width="1200"></line-chart>
        </div>
      </div>
      <div class="block__right-side">
        <a class="link-blue" @click="unloadClient">{{ $t('download') }} {{ $t('in') }} Excel</a>
      </div>
      <div class="form-body">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">{{ $t('named') }}</th>
            <th scope="col">{{ $t('count') }}</th>
            <th scope="col">{{ $t('active') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in statistics" v-bind:key="item.id">
            <th scope="row">{{ index + 1}}</th>
            <td>{{ item.name }}</td>
            <td>{{ item.visitCount }}</td>
            <td v-if="item.active == 1">{{ $t('active-1') }}</td>
            <td v-else>{{ $t('no-active') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import LineChart from "./charts/line-chart";
export default {
  name: 'statistics-branch',
  data: function(){
    return{
      branch: [],
      statistics: [],
      chartData: null,
      filter: {
        beforeDate: this.getBeforeDate(),
        afterDate: this.getAfterDate(),
        branch: 0,
      },
      isLoading: false,
      fullPage: true
    }
  },
  created: function(){
    this.getStatistics();
  },
  methods: {
    getAfterDate: function(){
      var dateOffset = (24*60*60*1000) * 30;
      var timestamp = new Date();
      var todayDate = new Date(timestamp - dateOffset).toISOString().slice(0, 10);
      return todayDate;
    },
    getBeforeDate: function(){
      var todayDate = new Date().toISOString().slice(0, 10);
      return todayDate;
    },
    getOptionsChart: function(){
      this.chartData = {
        labels: this.branch.map(c => c.date_visit),
        datasets: [
          {
            label: "Количество завершенных веток",
            data: this.branch.map(c => c.visitCount),
            backgroundColor: [
              'rgba(0,124,186, 0.2)',
              'rgba(0,124,186, 0.2)',
              'rgba(0,124,186, 0.2)',
              'rgba(0,124,186, 0.2)',
              'rgba(0,124,186, 0.2)',
              'rgba(0,124,186, 0.2)'
            ],
            borderColor: [
              'rgba(0,124,186, 1)',
              'rgba(0,124,186, 1)',
              'rgba(0,124,186, 1)',
              'rgba(0,124,186, 1)',
              'rgba(0,124,186, 1)',
              'rgba(0,124,186, 1)'
            ],
            borderWidth: 1
          },
        ],
      }
    },
    getStatistics: function(){
      this.isLoading = true;
      axios.post('getStatisticsBranch', this.filter).then(response => {
        var status = response.data.status;
        if(status){
          this.statistics = response.data.statistics;
          this.branch = response.data.chartBranch;
          this.getOptionsChart();
          this.isLoading = false;
        }
      });
    },
    unloadClient: function(){
      axios.post('unloadStatisticsBranch', this.filter).then(response => {
        var status = response.data.status;
        if(status){
          this.isLoading = false;
          let link = document.createElement('a');
          link.href = response.data.link;
          link.setAttribute('download', response.data.filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      });
    }
  },
  components: {
    loading, LineChart
  }
}
</script>